import {FC} from "react"
import {Widget} from "@dv5/domain"
import {WidgetComponent} from "../components/WidgetComponent"
import {OnNavigateToDocument, OnNavigateToTask, OnStopEditing, WidgetProps} from "../model/WidgetProps"
import './Widgets.less'

interface Props extends Omit<WidgetProps, 'widget' | 'selected' | 'onDeleteDataLink'> {
    widgets: Array<Widget>
    selection: Array<string>
    onStopEditing: OnStopEditing
    onNavigateToDocument: OnNavigateToDocument
    onNavigateToTask: OnNavigateToTask
}

export const Widgets: FC<Props> = ({widgets, selection, ...rest}) => {
    return (
        <>
            {widgets.map(widget => <WidgetComponent key={widget.id}
                                                    widget={widget}
                                                    selected={selection.includes(widget.id)}
                                                    {...rest}
            />)}
        </>
    )
}
